export class PublicRecordModel {
	propertyIdentifier?: string;
    streetNumber: string;
    unitNumber: string;
    streetDirPrefix: string;
    streetName: string;
    streetDirSuffix: string;
    parcelNumber: string;
    county: string;
    unparsedAddress?: any;
    city: string;
    state: string;
    postalCode: string;
    postalCodePlus4: string;
    legaLDescription: string;
    mapReference: string;
    tract: string;
    zoningClassification: string;
    subdivisionName: string;
    lotNumber?: any;
    mailUnparsedAddress?: any;
    mailCity?: any;
    mailState?: any;
    mailPostalCode?: any;
    mailPostalCodePlus4?: any;
    bathroomsTotal: number;
    bathroomsPartial?: any;
    bathroomsFull: number;
    bathroomsHalf: number;
    bedroomsTotal: number;
    buildingAreaTotal: number;
    totalFinishedArea: number;
    belowGradeTotal: number;
    belowGradeFinishedArea?: any;
    belowGradeUnfinishedArea: number;
    basement: string;
    garageSpaces?: any;
    heating?: any;
    lotSize: number;
    architecturalStyle: string;
    fireplacesTotal?: any;
    parkingFeatures: string;
    stories: number;
    roomsTotal?: any;
    yearBuilt: number;
    assessmentImprovementValue: number;
    assessmentLandValue: number;
    assessmentTotalValue: number;
    assessmentYear: number;
    marketImprovementValue?: any;
    marketLandValue?: any;
    marketTotalValue?: any;
    marketValueYear?: any;
    taxAmount: number;
    taxYear: number;
    mortgageDeeds?: MortageDeedModel[];
    transferDeeds?: TransferDeedModel[];
	ownerNames?: PublicRecordPersonaModel[];

	constructor() {
		this.mortgageDeeds = [];
		this.transferDeeds = [];
		this.ownerNames = [];
	}
}

export class DeedsBaseModel {
	sellers?: PublicRecordPersonaModel[];
    documentType: string;
    documentTypeCode?: any;
    bookNumber?: any;
    pageNumber?: any;
    documentNumber1: string;
    documentNumber2?: any;
    recordingDate: Date;
    saleDate: Date;
    salePrice: number;
}

export interface TransferDeedModel extends DeedsBaseModel {
    buyers?: PublicRecordPersonaModel[];
}

export class MortageDeedModel extends DeedsBaseModel {
	borrowers?: PublicRecordPersonaModel[];
	lenderName?: string;
	lenderType?: string;
	mortgageAmount?: number;
	mortgageTypeCode?: string;
	mortgageType?: string;
}

export interface PublicRecordPersonaModel {
    buyerType?: any;
    fullName: string;
    firstName?: any;
    lastName?: any;
}
